class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.cartForm = this.closest('cart-form');
  }

  connectedCallback() {
    if (this.cartForm) {
      this.observeCartFormChanges();
    }
    this.initOptions();
  }

  initOptions() {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(option => {
      option.addEventListener('click', () => this.selectOption(option));
    });

    const selects = this.querySelectorAll('.subs-frequency-select');
    selects.forEach(select => {
      select.addEventListener('change', () => this.selectFrequency(select));
    });
  }

  selectOption(option) {
    if (option.classList.contains('selected-plan')) return;

    const options = this.querySelectorAll('.subs-button');
    options.forEach(opt => opt.classList.remove('selected-plan'));
    option.classList.add('selected-plan');
    this.updateFormData(option);
    this.updateAtcPrice(option);
  }

  selectFrequency(select) {
    const option = select.closest('.subs-button');
    if (!option) return;

    option.setAttribute('data-plan-id', select.value);

    const selected = select.options[select.selectedIndex];
    if (selected?.dataset.priceLabel) {
      option.setAttribute('data-price-label', selected.dataset.priceLabel);
      const priceEl = option.querySelector('.subs-price');
      if (priceEl) priceEl.textContent = selected.dataset.priceLabel;
    }
    const frequencyText = option.querySelector('.subs-frequency-text');
    if (frequencyText && selected?.dataset.frequency) {
      frequencyText.textContent = selected.dataset.frequency;
    }

    if (option.classList.contains('selected-plan')) {
      this.updateFormData(option);
      this.updateAtcPrice(option);
    }
  }

  updateAtcPrice(option) {
    const priceLabel = option.getAttribute('data-price-label');
    if (!priceLabel) return;

    const scope = this.cartForm || this.closest('section') || document;
    scope.querySelectorAll('.AddToCart').forEach(button => {
      if (button.closest('cart-form') !== this.cartForm) return;
      if (button.disabled) return;
      // Buttons that hide their price leave it to the purchase options
      if (button.closest('[data-hide-price]')) return;
      const labelEl = button.querySelector('.button-label') || button.querySelector('span');
      if (!labelEl) return;
      const label = button.closest('product-card-add-to-cart')?.getAttribute('data-button-label') || 'Add to cart';
      labelEl.textContent = `${label} - ${priceLabel}`;
    });
  }

  updateFormData(option) {
    if (this.cartForm) {
      const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
      const items = Object.values(dataForm.items);
      const targetItem = items[0];

      if (targetItem) {
        const payload = {
          id: targetItem.id,
          quantity: targetItem.quantity,
          ...(option.getAttribute('data-plan-id') && {
            selling_plan: option.getAttribute('data-plan-id'),
          }),
          properties: {},
        };

        this.cartForm?.formDataAPI?.updateItems(payload);
      }
    }
  }

  observeCartFormChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
          this.handleCartFormUpdate();
        }
      }
    });

    observer.observe(this.cartForm.querySelector("#product-card-section"), { attributes: true, attributeFilter: ['data-product-card-selected_variant_id'] });

    window.addEventListener('beforeunload', () => observer.disconnect());
  }

  handleCartFormUpdate() {
    const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
    const variantId = Object.values(dataForm.items)?.[0]?.id;

    if (variantId) {
      this.classList.add("loading-plans");
      fetch(`${window.location.pathname}?variant=${variantId}`)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch updated section');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          const newContent = newDocument.querySelector('subs-widget');

          if (newContent) {
            this.replaceWith(newContent);
          }
        })
        .catch(error => {
          console.error('Error updating section:', error);
        });
    }
  }
}

customElements.define('subs-widget', SubscriptionWidget);